export const INSURER_LIST = [
   {
      "label": "Please select",
      "value": ""
   },
   {
      "label": "No Previous Insurance",
      "value": "No Previous Insurance"
   },
   {
      "label": "ACE",
      "value": "ACE"
   },
   {
      "label": "Ageas Insurance",
      "value": "Ageas Insurance"
   },
   {
      "label": "Allianz Cornhill Insurance Plc",
      "value": "Allianz Cornhill Insurance Plc"
   },
   {
      "label": "AmTrust Europe Limited",
      "value": "AmTrust Europe Limited"
   },
   {
      "label": "Arista",
      "value": "Arista"
   },
   {
      "label": "Aviva Insurance Limited",
      "value": "Aviva Insurance Limited"
   },
   {
      "label": "AXA Insurance Company Limited",
      "value": "AXA Insurance Company Limited"
   },
   {
      "label": "Brit Insurance",
      "value": "4Brit Insurance10"
   },
   {
      "label": "Canopius Underwriting Ltd",
      "value": ">Canopius Underwriting Ltd"
   },
   {
      "label": "Chartis Insurance",
      "value": "Chartis Insurance"
   },
   {
      "label": "Chaucer Insurance",
      "value": "Chaucer Insurance"
   },
   {
      "label": "Chubb Insurance Company of Europe SA",
      "value": "Chubb Insurance Company of Europe SA"
   },
   {
      "label": "CNA International Insurance Company, Birmingham",
      "value": "CNA International Insurance Company, Birmingham"
   },
   {
      "label": "Co-operative Insurance Society Limited",
      "value": "Co-operative Insurance Society Limited"
   },
   {
      "label": "Congregational & General Insurance PLC",
      "value": "Congregational & General Insurance PLC"
   },
   {
      "label": "Covea Insurance",
      "value": "Covea Insurance"
   },
   {
      "label": "Direct Line Insurance Limited",
      "value": "Direct Line Insurance Limited"
   },
   {
      "label": "Ecclesiastical Insurance Office Plc",
      "value": "Ecclesiastical Insurance Office Plc"
   },
   {
      "label": "Groupama Insurance Company Ltd",
      "value": "Groupama Insurance Company Ltd"
   },
   {
      "label": "Hiscox",
      "value": "Hiscox"
   },
   {
      "label": "HSB EIL Engineering",
      "value": "HSB EIL Engineering"
   },
   {
      "label": "HSBC",
      "value": "HSBC"
   },
   {
      "label": "Legal & General Insurance Limited",
      "value": "Legal & General Insurance Limited"
   },
   {
      "label": "Liverpool Victoria",
      "value": "Liverpool Victoria"
   },
   {
      "label": "Lloyds TSB General Insurance",
      "value": "Lloyds TSB General Insurance"
   },
   {
      "label": "Markel (UK) Ltd",
      "value": "Markel (UK) Ltd"
   },
   {
      "label": "Markerstudy Ltd",
      "value": "Markerstudy Ltd<"
   },
   {
      "label": "MMA Insurance plc",
      "value": "MMA Insurance plc"
   },
   {
      "label": "Nat West",
      "value": "Nat West"
   },
   {
      "label": "New India Assurance Company Limited",
      "value": "New India Assurance Company Limited"
   },
   {
      "label": "NIG",
      "value": "NIG"
   },
   {
      "label": "Novae",
      "value": "Novae"
   },
   {
      "label": "QBE International Insurance Limited",
      "value": "QBE International Insurance Limited"
   },
   {
      "label": "Quinn Direct",
      "value": "Quinn Direct"
   },
   {
      "label": "Royal & Sun Alliance",
      "value": "Royal & Sun Alliance"
   },
   {
      "label": "Royal Bank of Scotland PLC",
      "value": "Royal Bank of Scotland PLC"
   },
   {
      "label": "Towergate Insurance",
      "value": "Towergate Insurance"
   },
   {
      "label": "Unknown",
      "value": "Unknown"
   },
   {
      "label": "Unlisted Insurer",
      "value": "Unlisted Insurer"
   },
   {
      "label": "Vasek Insurance",
      "value": "Vasek Insurance"
   },
   {
      "label": "Zurich Insurance Company",
      "value": "Zurich Insurance Company"
   }
];

export const BUSINESS_TYPE_OPTIONS = [
   {
      "label": "Please select",
      "value": ""
   },
   {
      "label": "Individual Trading as",
      "value": "Individual Trading as"
   },
   {
      "label": "Limited",
      "value": "Limited"
   },
   {
      "label": "Partnership",
      "value": "Partnership"
   },
   {
      "label": "Public Limited",
      "value": "Public Limited"
   }
];

export const BUSINESS_CATEGORY_OPTIONS = [
   {
      "label": " Please select",
      "value": ""
   },
   {
      "label": "Adult Bookstore",
      "value": "Adult Bookstore"
   },
   {
      "label": "Amusements",
      "value": "Amusements"
   },
   {
      "label": "Antique Furniture Retailing",
      "value": "Antique Furniture Retailing"
   },
   {
      "label": "Antique/Rare Book Retailing",
      "value": "Antique/Rare Book Retailing"
   },
   {
      "label": "Antiques Retailing",
      "value": "Antiques Retailing"
   },
   {
      "label": "Aquarium Supplier",
      "value": "Aquarium Supplier"
   },
   {
      "label": "Art Gallery",
      "value": "Art Gallery"
   },
   {
      "label": "Art Restoration",
      "value": "Art Restoration"
   },
   {
      "label": "Artist Materials Retailing",
      "value": "Artist Materials Retailing"
   },
   {
      "label": "Arts & Crafts Retailing",
      "value": "Arts &amp; Crafts Retailing"
   },
   {
      "label": "Audio / Visual Media Retailing",
      "value": "Audio / Visual Media Retailing"
   },
   {
      "label": "Baby Goods Retailing",
      "value": "Baby Goods Retailing"
   },
   {
      "label": "Babywear Retailing",
      "value": "Babywear Retailing"
   },
   {
      "label": "Baker",
      "value": "Baker"
   },
   {
      "label": "Bakers Produce Retailing (excluding Baking)",
      "value": "Bakers Produce Retailing (excluding Baking)"
   },
   {
      "label": "Bakery",
      "value": "Bakery"
   },
   {
      "label": "Basket And/Or Brushware Retailer",
      "value": "Basket And/Or Brushware Retailer"
   },
   {
      "label": "Bathroom Equipment Retailing",
      "value": "Bathroom Equipment Retailing"
   },
   {
      "label": "Beautician including Hairdressing",
      "value": "Beautician including Hairdressing"
   },
   {
      "label": "Beauty Products",
      "value": "Beauty Products"
   },
   {
      "label": "Beauty Salon",
      "value": "Beauty Salon"
   },
   {
      "label": "Bed Retailing",
      "value": "Bed Retailing"
   },
   {
      "label": "Bedding Retailing",
      "value": "Bedding Retailing"
   },
   {
      "label": "Belts / Scarves / Gloves Retailing",
      "value": "Belts / Scarves / Gloves Retailing"
   },
   {
      "label": "Bingo Hall",
      "value": "Bingo Hall"
   },
   {
      "label": "Boat Hiring",
      "value": "Boat Hiring"
   },
   {
      "label": "Boat Retailing",
      "value": "Boat Retailing"
   },
   {
      "label": "Bookmaking - Off Course",
      "value": "Bookmaking - Off Course"
   },
   {
      "label": "Bookselling",
      "value": "Bookselling"
   },
   {
      "label": "Bookselling - Secondhand",
      "value": "Bookselling - Secondhand"
   },
   {
      "label": "Boutique",
      "value": "Boutique"
   },
   {
      "label": "Bridal Wear Retailing",
      "value": "Bridal Wear Retailing"
   },
   {
      "label": "Builders Merchant",
      "value": "Builders Merchant"
   },
   {
      "label": "Burger Bar",
      "value": "Burger Bar"
   },
   {
      "label": "Butcher",
      "value": "Butcher"
   },
   {
      "label": "Café",
      "value": "Café"
   },
   {
      "label": "Café (ex Deep Fat Frying)",
      "value": "Café (ex Deep Fat Frying)"
   },
   {
      "label": "Cake Making & Decorating",
      "value": "Cake Making &amp; Decorating"
   },
   {
      "label": "Camping and Outdoor Retailing",
      "value": "Camping and Outdoor Retailing"
   },
   {
      "label": "Candle Dealing",
      "value": "Candle Dealing"
   },
   {
      "label": "Car Accessory Shop",
      "value": "Car Accessory Shop"
   },
   {
      "label": "Car Radio Dealers inc fitting",
      "value": "Car Radio Dealers inc fitting"
   },
   {
      "label": "Carpet (Oriental/Persian) Retailing",
      "value": "Carpet (Oriental/Persian) Retailing"
   },
   {
      "label": "Carpet Retailing",
      "value": "Carpet Retailing"
   },
   {
      "label": "Cash & Carry",
      "value": "Cash &amp; Carry"
   },
   {
      "label": "Catering Equipment Supplying",
      "value": "Catering Equipment Supplying"
   },
   {
      "label": "Ceramics And Pottery",
      "value": "Ceramics And Pottery"
   },
   {
      "label": "Chandlery",
      "value": "Chandlery"
   },
   {
      "label": "Charity Shop",
      "value": "Charity Shop"
   },
   {
      "label": "Chauffeur Services",
      "value": "Chauffeur Services"
   },
   {
      "label": "Cheese Retailer",
      "value": "Cheese Retailer"
   },
   {
      "label": "Chemist - Dispensing",
      "value": "Chemist - Dispensing"
   },
   {
      "label": "Chemist - Non Dispensing",
      "value": "Chemist - Non Dispensing"
   },
   {
      "label": "Children's Clothing Retailing",
      "value": "Children's Clothing Retailing"
   },
   {
      "label": "Children’s Play Centre",
      "value": "Children’s Play Centre"
   },
   {
      "label": "China And/Or Glassware Retailing",
      "value": "China And/Or Glassware Retailing"
   },
   {
      "label": "Christmas Goods Supplier",
      "value": "Christmas Goods Supplier"
   },
   {
      "label": "Clock & Watch Repair",
      "value": "Clock &amp; Watch Repair"
   },
   {
      "label": "Clock & Watch Retailing",
      "value": "Clock &amp; Watch Retailing"
   },
   {
      "label": "Clothing Hire - Fancy Dress",
      "value": "Clothing Hire - Fancy Dress"
   },
   {
      "label": "Clothing Hiring",
      "value": "Clothing Hiring"
   },
   {
      "label": "Clothing Retailing",
      "value": "Clothing Retailing"
   },
   {
      "label": "Coffee And Tea Retailing",
      "value": "Coffee And Tea Retailing"
   },
   {
      "label": "Coffee Shop",
      "value": "Coffee Shop"
   },
   {
      "label": "Coin & Medal Dealing",
      "value": "Coin &amp; Medal Dealing"
   },
   {
      "label": "Computer Games Retailing",
      "value": "Computer Games Retailing"
   },
   {
      "label": "Computer Retailing - Business",
      "value": "Computer Retailing - Business"
   },
   {
      "label": "Computer Retailing - General",
      "value": "Computer Retailing - General"
   },
   {
      "label": "Computer Retailing - Home & Games",
      "value": "Computer Retailing - Home &amp; Games"
   },
   {
      "label": "Computer Supplies",
      "value": "Computer Supplies"
   },
   {
      "label": "Confectionery Retailer",
      "value": "Confectionery Retailer"
   },
   {
      "label": "Consulting Optician",
      "value": "Consulting Optician"
   },
   {
      "label": "Cosmetics",
      "value": "Cosmetics"
   },
   {
      "label": "Curios Retailing",
      "value": "Curios Retailing"
   },
   {
      "label": "Curtain & Blind Retailer",
      "value": "Curtain &amp; Blind Retailer"
   },
   {
      "label": "Cutlery Retailing",
      "value": "Cutlery Retailing"
   },
   {
      "label": "Cycle Hiring",
      "value": "Cycle Hiring"
   },
   {
      "label": "Cycle Repairing",
      "value": "Cycle Repairing"
   },
   {
      "label": "Cycle Shop",
      "value": "Cycle Shop"
   },
   {
      "label": "Dairy Products Retailing",
      "value": "Dairy Products Retailing"
   },
   {
      "label": "Decorators Merchant",
      "value": "Decorators Merchant"
   },
   {
      "label": "Delicatessen",
      "value": "Delicatessen"
   },
   {
      "label": "Department Store",
      "value": "Department Store"
   },
   {
      "label": "DIY - Including Timber",
      "value": "DIY - Including Timber"
   },
   {
      "label": "DIY Store",
      "value": "DIY Store"
   },
   {
      "label": "Dog Beautician",
      "value": "Dog Beautician"
   },
   {
      "label": "Dolls/Dolls House Retailing",
      "value": "Dolls/Dolls House Retailing"
   },
   {
      "label": "Double Glazing & Replacement Window Showroom",
      "value": "Double Glazing &amp; Replacement Window Showroom"
   },
   {
      "label": "Draper",
      "value": "Draper"
   },
   {
      "label": "Dress Agency",
      "value": "Dress Agency"
   },
   {
      "label": "Drug Store",
      "value": "Drug Store"
   },
   {
      "label": "Dry Cleaning",
      "value": "Dry Cleaning"
   },
   {
      "label": "Dry Cleaning (Receiving Service)",
      "value": "Dry Cleaning (Receiving Service)"
   },
   {
      "label": "Dry Cleaning and Laundry (Receiving Service)",
      "value": "Dry Cleaning and Laundry (Receiving Service)"
   },
   {
      "label": "Electric Tool Retailer",
      "value": "Electric Tool Retailer"
   },
   {
      "label": "Electrical Goods (Domestic) Repair",
      "value": "Electrical Goods (Domestic) Repair"
   },
   {
      "label": "Electrical Goods Hiring - Domestic Appliance",
      "value": "Electrical Goods Hiring - Domestic Appliance"
   },
   {
      "label": "Electrical Goods Retailing",
      "value": "Electrical Goods Retailing"
   },
   {
      "label": "Electrical Goods Retailing - Domestic Appliance",
      "value": "Electrical Goods Retailing - Domestic Appliance"
   },
   {
      "label": "Electrical Goods Retailing - HI FI Audio TV etc.",
      "value": "Electrical Goods Retailing - HI FI Audio TV etc."
   },
   {
      "label": "Electrical Goods Retailing - White Goods",
      "value": "Electrical Goods Retailing - White Goods"
   },
   {
      "label": "Engraving",
      "value": "Engraving"
   },
   {
      "label": "Fabric Retailing",
      "value": "Fabric Retailing"
   },
   {
      "label": "Fancy Goods Retailing",
      "value": "Fancy Goods Retailing"
   },
   {
      "label": "Farm Produce Retailing",
      "value": "Farm Produce Retailing"
   },
   {
      "label": "Fashion Accessories Retailing",
      "value": "Fashion Accessories Retailing"
   },
   {
      "label": "Fashion Boutique",
      "value": "Fashion Boutique"
   },
   {
      "label": "Fashion Retailing",
      "value": "Fashion Retailing"
   },
   {
      "label": "Fast Food Retailing",
      "value": "Fast Food Retailing"
   },
   {
      "label": "Filling Station",
      "value": "Filling Station"
   },
   {
      "label": "Film Processing",
      "value": "Film Processing"
   },
   {
      "label": "Financial Market Trading",
      "value": "Financial Market Trading"
   },
   {
      "label": "Fireplace Retailing",
      "value": "Fireplace Retailing"
   },
   {
      "label": "Fish & Chip Shop",
      "value": "Fish &amp; Chip Shop"
   },
   {
      "label": "Fishing Tackle Retailing",
      "value": "Fishing Tackle Retailing"
   },
   {
      "label": "Fishmonger",
      "value": "Fishmonger"
   },
   {
      "label": "Florist",
      "value": "Florist"
   },
   {
      "label": "Food Store",
      "value": "Food Store"
   },
   {
      "label": "Footwear Retailing",
      "value": "Footwear Retailing"
   },
   {
      "label": "Forklift Driving Training",
      "value": "Forklift Driving Training"
   },
   {
      "label": "Freezer Centre",
      "value": "Freezer Centre"
   },
   {
      "label": "Frozen Food Retailing",
      "value": "Frozen Food Retailing"
   },
   {
      "label": "Funeral Director",
      "value": "Funeral Director"
   },
   {
      "label": "Fur Retailing",
      "value": "Fur Retailing"
   },
   {
      "label": "Furniture (Flat Pack) Retailing",
      "value": "Furniture (Flat Pack) Retailing"
   },
   {
      "label": "Furniture Repairing",
      "value": "Furniture Repairing"
   },
   {
      "label": "Furniture Restoration",
      "value": "Furniture Restoration"
   },
   {
      "label": "Furniture Retailing",
      "value": "Furniture Retailing"
   },
   {
      "label": "Furniture Retailing - Fitted",
      "value": "Furniture Retailing - Fitted"
   },
   {
      "label": "Furniture Retailing - Nursery",
      "value": "Furniture Retailing - Nursery"
   },
   {
      "label": "Furniture Retailing - Second-hand",
      "value": "Furniture Retailing - Second-hand"
   },
   {
      "label": "Furrier",
      "value": "Furrier"
   },
   {
      "label": "Garden Centre",
      "value": "Garden Centre"
   },
   {
      "label": "Garden Equipment Retailing",
      "value": "Garden Equipment Retailing"
   },
   {
      "label": "Garden Supplies Shop",
      "value": "Garden Supplies Shop"
   },
   {
      "label": "General Store",
      "value": "General Store"
   },
   {
      "label": "Gift Shop",
      "value": "Gift Shop"
   },
   {
      "label": "Glass Merchant",
      "value": "Glass Merchant"
   },
   {
      "label": "Glass or Glass Goods Decorator / Engraver",
      "value": "Glass or Glass Goods Decorator / Engraver"
   },
   {
      "label": "Glassware Retailer",
      "value": "Glassware Retailer"
   },
   {
      "label": "Glazier",
      "value": "Glazier"
   },
   {
      "label": "Goldsmith",
      "value": "Goldsmith"
   },
   {
      "label": "Golf Equipment Retailing",
      "value": "Golf Equipment Retailing"
   },
   {
      "label": "Golf Professionals Shop",
      "value": "Golf Professionals Shop"
   },
   {
      "label": "Gown Trade",
      "value": "Gown Trade"
   },
   {
      "label": "Greengrocer",
      "value": "Greengrocer"
   },
   {
      "label": "Greeting Card Retailing",
      "value": "Greeting Card Retailing"
   },
   {
      "label": "Grocer",
      "value": "Grocer"
   },
   {
      "label": "Grocer - Licensed",
      "value": "Grocer - Licensed"
   },
   {
      "label": "Guest House",
      "value": "Guest House"
   },
   {
      "label": "Gun Retailing",
      "value": "Gun Retailing"
   },
   {
      "label": "Gunsmith",
      "value": "Gunsmith"
   },
   {
      "label": "Haberdashery",
      "value": "Haberdashery"
   },
   {
      "label": "Hairdressing",
      "value": "Hairdressing"
   },
   {
      "label": "Hairpiece And Wig Retailing",
      "value": "Hairpiece And Wig Retailing"
   },
   {
      "label": "Handicraft Retailing",
      "value": "Handicraft Retailing"
   },
   {
      "label": "Hardware Retailing",
      "value": "Hardware Retailing"
   },
   {
      "label": "Hatter",
      "value": "Hatter"
   },
   {
      "label": "Health Food Retailer",
      "value": "Health Food Retailer"
   },
   {
      "label": "Herbs and Spices Retailing",
      "value": "Herbs and Spices Retailing"
   },
   {
      "label": "Hobby Shop",
      "value": "Hobby Shop"
   },
   {
      "label": "Home Brew Materials Retailing",
      "value": "Home Brew Materials Retailing"
   },
   {
      "label": "Horticultural Goods Retailing",
      "value": "Horticultural Goods Retailing"
   },
   {
      "label": "Hosiery",
      "value": "Hosiery"
   },
   {
      "label": "Hotel",
      "value": "Hotel"
   },
   {
      "label": "Household Goods Retailing",
      "value": "Household Goods Retailing"
   },
   {
      "label": "Ice Cream Parlour",
      "value": "Ice Cream Parlour"
   },
   {
      "label": "In Car Entertainment Retailing",
      "value": "In Car Entertainment Retailing"
   },
   {
      "label": "Industrial Safetywear Retailing",
      "value": "Industrial Safetywear Retailing"
   },
   {
      "label": "Interior Designer including fitting",
      "value": "Interior Designer including fitting"
   },
   {
      "label": "Internet Cafe",
      "value": "Internet Cafe"
   },
   {
      "label": "Intruder Alarm Retailing",
      "value": "Intruder Alarm Retailing"
   },
   {
      "label": "Ironing Service",
      "value": "Ironing Service"
   },
   {
      "label": "Ironmonger",
      "value": "Ironmonger"
   },
   {
      "label": "Jewellery Retailer",
      "value": "Jewellery Retailer"
   },
   {
      "label": "Key Cutter",
      "value": "Key Cutter"
   },
   {
      "label": "Kitchen Accessories Retailing",
      "value": "Kitchen Accessories Retailing"
   },
   {
      "label": "Kitchen/Bathroom Unit Showroom",
      "value": "Kitchen/Bathroom Unit Showroom"
   },
   {
      "label": "Knitting Machine Shop",
      "value": "Knitting Machine Shop"
   },
   {
      "label": "Knitwear Retailing",
      "value": "Knitwear Retailing"
   },
   {
      "label": "Lamp Shop",
      "value": "Lamp Shop"
   },
   {
      "label": "Launderette (attended)",
      "value": "Launderette (attended)"
   },
   {
      "label": "Launderette (unattended)",
      "value": "Launderette (unattended)"
   },
   {
      "label": "Leather and Travel Goods",
      "value": "Leather and Travel Goods"
   },
   {
      "label": "Leather Clothing Retailing",
      "value": "Leather Clothing Retailing"
   },
   {
      "label": "Leather Goods Retailing - Excluding Clothes",
      "value": "Leather Goods Retailing - Excluding Clothes"
   },
   {
      "label": "Leather Goods Retailing - Including Clothes",
      "value": "Leather Goods Retailing - Including Clothes"
   },
   {
      "label": "Leisurewear Retailing",
      "value": "Leisurewear Retailing"
   },
   {
      "label": "Light Fitting Retailing",
      "value": "Light Fitting Retailing"
   },
   {
      "label": "Lighting Retailing",
      "value": "Lighting Retailing"
   },
   {
      "label": "Linen Hire",
      "value": "Linen Hire"
   },
   {
      "label": "Linen Retailing",
      "value": "Linen Retailing"
   },
   {
      "label": "Lingerie Retailing",
      "value": "Lingerie Retailing"
   },
   {
      "label": "Locksmith",
      "value": "Locksmith"
   },
   {
      "label": "Lottery Agent",
      "value": "Lottery Agent"
   },
   {
      "label": "Luggage and Handbag Retailing",
      "value": "Luggage and Handbag Retailing"
   },
   {
      "label": "Marine Stores",
      "value": "Marine Stores"
   },
   {
      "label": "Maternity Wear Retailing",
      "value": "Maternity Wear Retailing"
   },
   {
      "label": "Meat Market",
      "value": "Meat Market"
   },
   {
      "label": "Menswear Retailer",
      "value": "Menswear Retailer"
   },
   {
      "label": "Millinery",
      "value": "Millinery"
   },
   {
      "label": "Mini Cab Operator",
      "value": "Mini Cab Operator"
   },
   {
      "label": "Mobile Phone Retailing",
      "value": "Mobile Phone Retailing"
   },
   {
      "label": "Mobile Shop",
      "value": "Mobile Shop"
   },
   {
      "label": "Model Shop",
      "value": "Model Shop"
   },
   {
      "label": "Motor Accessories Retailing",
      "value": "Motor Accessories Retailing"
   },
   {
      "label": "Motor Accessories Retailing (excl In-Car Entertainment)",
      "value": "Motor Accessories Retailing (excl In-Car Entertainment)"
   },
   {
      "label": "Motorcycle Accessories Retailing",
      "value": "Motorcycle Accessories Retailing"
   },
   {
      "label": "Music Retailing",
      "value": "Music Retailing"
   },
   {
      "label": "Musical Instrument Retailing",
      "value": "Musical Instrument Retailing"
   },
   {
      "label": "Nail Technician",
      "value": "Nail Technician"
   },
   {
      "label": "Newsagent",
      "value": "Newsagent"
   },
   {
      "label": "Novelty/Carnival Goods Retailing",
      "value": "Novelty/Carnival Goods Retailing"
   },
   {
      "label": "Nursery Goods Shop",
      "value": "Nursery Goods Shop"
   },
   {
      "label": "Off Licence",
      "value": "Off Licence"
   },
   {
      "label": "Office Equipment Supplier (excluding Electrical)",
      "value": "Office Equipment Supplier (excluding Electrical)"
   },
   {
      "label": "Office Equipment Supplier (including Electrical)",
      "value": "Office Equipment Supplier (including Electrical)"
   },
   {
      "label": "Office Furniture Retailing",
      "value": "Office Furniture Retailing"
   },
   {
      "label": "Office Supplies Retailing",
      "value": "Office Supplies Retailing"
   },
   {
      "label": "Optician",
      "value": "Optician"
   },
   {
      "label": "Organic Foods Retailing",
      "value": "Organic Foods Retailing"
   },
   {
      "label": "Orthopaedic Equipment Retailer",
      "value": "Orthopaedic Equipment Retailer"
   },
   {
      "label": "Paint And/Or Wallpaper Retailing",
      "value": "Paint And/Or Wallpaper Retailing"
   },
   {
      "label": "Pawnbroking",
      "value": "Pawnbroking"
   },
   {
      "label": "Pens Retailing",
      "value": "Pens Retailing"
   },
   {
      "label": "Perambulator Retailing",
      "value": "Perambulator Retailing"
   },
   {
      "label": "Perfume Retailing",
      "value": "Perfume Retailing"
   },
   {
      "label": "Pet Accessory/Food Store",
      "value": "Pet Accessory/Food Store"
   },
   {
      "label": "Pet Parlour",
      "value": "Pet Parlour"
   },
   {
      "label": "Pet Shop",
      "value": "Pet Shop"
   },
   {
      "label": "Petrol Station",
      "value": "Petrol Station"
   },
   {
      "label": "Pharmaceutical Wholesaler",
      "value": "Pharmaceutical Wholesaler"
   },
   {
      "label": "Pharmacy",
      "value": "Pharmacy"
   },
   {
      "label": "Photo Engraving",
      "value": "Photo Engraving"
   },
   {
      "label": "Photo Processing And Printing",
      "value": "Photo Processing And Printing"
   },
   {
      "label": "Photocopying",
      "value": "Photocopying"
   },
   {
      "label": "Photographic Equipment Retailing",
      "value": "Photographic Equipment Retailing"
   },
   {
      "label": "Photographic Studio",
      "value": "Photographic Studio"
   },
   {
      "label": "Piano Retailing",
      "value": "Piano Retailing"
   },
   {
      "label": "Piano Retailing And Repair",
      "value": "Piano Retailing And Repair"
   },
   {
      "label": "Picture Framing",
      "value": "Picture Framing"
   },
   {
      "label": "Picture Shop",
      "value": "Picture Shop"
   },
   {
      "label": "Pine And Cane Furniture Retailing",
      "value": "Pine And Cane Furniture Retailing"
   },
   {
      "label": "Pizza Delivery",
      "value": "Pizza Delivery"
   },
   {
      "label": "Plumbers Merchant",
      "value": "Plumbers Merchant"
   },
   {
      "label": "Pool and Snooker Table Retailing",
      "value": "Pool and Snooker Table Retailing"
   },
   {
      "label": "Post Office",
      "value": "Post Office"
   },
   {
      "label": "Post Office - Sub",
      "value": "Post Office - Sub"
   },
   {
      "label": "Post Office Services",
      "value": "Post Office Services"
   },
   {
      "label": "Pottery",
      "value": "Pottery"
   },
   {
      "label": "Poultry And Game Retailing",
      "value": "Poultry And Game Retailing"
   },
   {
      "label": "Print Shop",
      "value": "Print Shop"
   },
   {
      "label": "Public House",
      "value": "Public House"
   },
   {
      "label": "Record CD Cassette & Video/DVD Retailing",
      "value": "Record CD Cassette &amp; Video/DVD Retailing"
   },
   {
      "label": "Record Shop",
      "value": "Record Shop"
   },
   {
      "label": "Restaurant - Licensed",
      "value": "Restaurant - Licensed"
   },
   {
      "label": "Restaurant - unlicensed",
      "value": "Restaurant - unlicensed"
   },
   {
      "label": "Rope Merchant",
      "value": "Rope Merchant"
   },
   {
      "label": "Saddlery And Tack Retailing",
      "value": "Saddlery And Tack Retailing"
   },
   {
      "label": "Safety Equipment Supplier",
      "value": "Safety Equipment Supplier"
   },
   {
      "label": "Sailing Equipment Supplier",
      "value": "Sailing Equipment Supplier"
   },
   {
      "label": "Sandwich Bar",
      "value": "Sandwich Bar"
   },
   {
      "label": "Scientific Instrument Retailing",
      "value": "Scientific Instrument Retailing"
   },
   {
      "label": "Scrap Metal Merchant",
      "value": "Scrap Metal Merchant"
   },
   {
      "label": "Second-hand Dealing",
      "value": "Second-hand Dealing"
   },
   {
      "label": "Sewing Machine Shop",
      "value": "Sewing Machine Shop"
   },
   {
      "label": "Sex Shop",
      "value": "Sex Shop"
   },
   {
      "label": "Sharpening Service",
      "value": "Sharpening Service"
   },
   {
      "label": "Shirt Retailing",
      "value": "Shirt Retailing"
   },
   {
      "label": "Shoe Repairing",
      "value": "Shoe Repairing"
   },
   {
      "label": "Shoe Retailing",
      "value": "Shoe Retailing"
   },
   {
      "label": "Silversmith",
      "value": "Silversmith"
   },
   {
      "label": "Silverware Retailing",
      "value": "Silverware Retailing"
   },
   {
      "label": "Sofa Bed Retailing",
      "value": "Sofa Bed Retailing"
   },
   {
      "label": "Soft Furnishings Retailing",
      "value": "Soft Furnishings Retailing"
   },
   {
      "label": "Souvenir Retailing",
      "value": "Souvenir Retailing"
   },
   {
      "label": "Sports Goods Retailing",
      "value": "Sports Goods Retailing"
   },
   {
      "label": "Sportswear Supplier",
      "value": "Sportswear Supplier"
   },
   {
      "label": "Stamp Collecting Retailer",
      "value": "Stamp Collecting Retailer"
   },
   {
      "label": "Stationer",
      "value": "Stationer"
   },
   {
      "label": "Street/Market Trading",
      "value": "Street/Market Trading"
   },
   {
      "label": "Supermarket",
      "value": "Supermarket"
   },
   {
      "label": "Surgical Equipment Retailer",
      "value": "Surgical Equipment Retailer"
   },
   {
      "label": "Sweet Shop",
      "value": "Sweet Shop"
   },
   {
      "label": "Tableware Retailer",
      "value": "Tableware Retailer"
   },
   {
      "label": "Tailor And Outfitter",
      "value": "Tailor And Outfitter"
   },
   {
      "label": "Take Away Food Retailer",
      "value": "Take Away Food Retailer"
   },
   {
      "label": "Takeaways",
      "value": "Takeaways"
   },
   {
      "label": "Tea Room",
      "value": "Tea Room"
   },
   {
      "label": "Telecommunication Equipment Supplier",
      "value": "Telecommunication Equipment Supplier"
   },
   {
      "label": "Telephone Sales Retailing",
      "value": "Telephone Sales Retailing"
   },
   {
      "label": "Television Hiring",
      "value": "Television Hiring"
   },
   {
      "label": "Television Repairing",
      "value": "Television Repairing"
   },
   {
      "label": "Television Retailing",
      "value": "Television Retailing"
   },
   {
      "label": "Textile Retailing",
      "value": "Textile Retailing"
   },
   {
      "label": "Tile Retailer",
      "value": "Tile Retailer"
   },
   {
      "label": "Tobacconist",
      "value": "Tobacconist"
   },
   {
      "label": "Toiletries Retailing",
      "value": "Toiletries Retailing"
   },
   {
      "label": "Tool Hire",
      "value": "Tool Hire"
   },
   {
      "label": "Tool Hire - Hand",
      "value": "Tool Hire - Hand"
   },
   {
      "label": "Tool Hire - Power Driven",
      "value": "Tool Hire - Power Driven"
   },
   {
      "label": "Tool Retailer",
      "value": "Tool Retailer"
   },
   {
      "label": "Toy And Game Retailing",
      "value": "Toy And Game Retailing"
   },
   {
      "label": "Trophy Retailing",
      "value": "Trophy Retailing"
   },
   {
      "label": "Turf Accountant",
      "value": "Turf Accountant"
   },
   {
      "label": "TV & Video Repairing",
      "value": "TV &amp; Video Repairing"
   },
   {
      "label": "TV And Radio",
      "value": "TV And Radio"
   },
   {
      "label": "TV And Video Rental",
      "value": "TV And Video Rental"
   },
   {
      "label": "Tyre Battery & Exhaust Retailing/Fitter",
      "value": "Tyre Battery &amp; Exhaust Retailing/Fitter"
   },
   {
      "label": "Undertaker",
      "value": "Undertaker"
   },
   {
      "label": "Upholstery",
      "value": "Upholstery"
   },
   {
      "label": "Venetian Blind Supplier",
      "value": "Venetian Blind Supplier"
   },
   {
      "label": "Video/DVD Hire",
      "value": "Video/DVD Hire"
   },
   {
      "label": "Wallpaper Shop",
      "value": "Wallpaper Shop"
   },
   {
      "label": "Watch And Clock Retailing",
      "value": "Watch And Clock Retailing"
   },
   {
      "label": "Wine Retailer",
      "value": "Wine Retailer"
   },
   {
      "label": "Wool And Needlework Shop",
      "value": "Wool And Needlework Shop"
   },
   {
      "label": "Woollen Goods Shop",
      "value": "Woollen Goods Shop"
   },
   {
      "label": "Yacht Chandlery",
      "value": "Yacht Chandlery"
   },
   {
      "label": "Other",
      "value": "Other"
   }
];

export const BUSINESS_PREMISE_LOCATION_OPTIONS = [
   {
      "label": "Please select",
      "value": ""
   },
   {
      "label": "Arcade",
      "value": "Arcade"
   },
   {
      "label": "Business Park",
      "value": "Business Park"
   },
   {
      "label": "Covered Shopping centre",
      "value": "Covered Shopping centre"
   },
   {
      "label": "Domestic Premises",
      "value": "Domestic Premises"
   },
   {
      "label": "High Street",
      "value": "High Street"
   },
   {
      "label": "In Building Otherwise Occupied As Dwellings",
      "value": "In Building Otherwise Occupied As Dwellings"
   },
   {
      "label": "Industrial Estate",
      "value": "Industrial Estate"
   },
   {
      "label": "Industrial Unit",
      "value": "Industrial Unit"
   },
   {
      "label": "Market Hall",
      "value": "Market Hall"
   },
   {
      "label": "On Office Premises",
      "value": "On Office Premises"
   },
   {
      "label": "Parade",
      "value": "Parade"
   },
   {
      "label": "Precinct",
      "value": "Precinct"
   },
   {
      "label": "Warehouse",
      "value": "Warehouse"
   }
];

export const PREMISE_ROOFING_TYPE_OPTIONS = [
   {
      "label": "Please select",
      "value": ""
   },
   {
      "label": "Flat Roof",
      "value": "Flat Roof"
   },
   {
      "label": "Slope Roof",
      "value": "Slope Roof"
   }
]

export const PREMISE_FLOORING_TYPE_OPTIONS = [
   {
      "label": "Please select",
      "value": ""
   },
   {
      "label": "Concrete Floor",
      "value": "Concrete Floor"
   },
   {
      "label": "Wooden Floor",
      "value": "Wooden Floor",
   }
]

export const PREMISE_WALL_TYPE_OPTIONS = [
   {
      "label": "Please select",
      "value": ""
   },
   {
      "label": "Concrete Wall",
      "value": "Concrete Wall"
   },
   {
      "label": "Brick Wall",
      "value": "Brick Wall"
   },
   {
      "label": "Wood Wall",
      "value": "Wood Wall"
   }
]

export const PREMISE_OCCUPATION_TIME_OPTIONS = [
   {
      "label": "Please select",
      "value": ""
   },
   {
      "label": "24 Hours",
      "value": "24 Hours"
   },
   {
      "label": "Business Hours",
      "value": "Business Hours"
   },
   {
      "label": "Unoccupied",
      "value": "Unoccupied"
   }
]

export const PREMISE_TENURE_TYPE_OPTIONS = [
   {
      "label": "Please select",
      "value": ""
   },
   {
      "label": "Owned",
      "value": "Owned"
   },
   {
      "label": "Leased",
      "value": "Leased"
   },
   {
      "label": "Rented",
      "value": "Rented"
   }
]